// extracted by mini-css-extract-plugin
export default {"wrapper":"main_wrapper__3pLUm","row":"main_row__sZp2i"};